import React, { useState, useEffect } from 'react';
import FineManagement from './FineManagement';
import ConsolidatedData from './ConsolidatedData';
import AppealHistory from './AppealHistory';
import './Dashboard.css';
import FeedbackWidget from './FeedbackWidget';

function Dashboard({ user, onLogout, onNavigate, currentTab }) {
  const [activeTab, setActiveTab] = useState(currentTab || 'dashboard');

  useEffect(() => {
    if (currentTab) {
      setActiveTab(currentTab);
    }
  }, [currentTab]);

  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <div className="sidebar-header">
          <img src="/logo.png" alt="Logo" className="company-logo" />
        </div>
        
        <nav className="sidebar-nav">
          <div className="nav-section">
            <span className="nav-section-title">Geral</span>
            <button 
              className={activeTab === 'dashboard' ? 'active' : ''} 
              onClick={() => setActiveTab('dashboard')}
            >
              <span className="icon">📊</span>
              Dashboard
            </button>
          </div>

          <div className="nav-section">
            <span className="nav-section-title">Ferramentas</span>
            <button 
              className={activeTab === 'insights' ? 'active' : ''} 
              onClick={() => setActiveTab('insights')}
            >
              <span className="icon">💡</span>
              SARInsights
            </button>
            <button 
              className={activeTab === 'chat' ? 'active' : ''} 
              onClick={() => setActiveTab('chat')}
            >
              <span className="icon">💬</span>
              SARzinho
            </button>
          </div>

          <div className="nav-section">
            <span className="nav-section-title">Gestão de Multas</span>
            <button 
              className={activeTab === 'fines' ? 'active' : ''} 
              onClick={() => setActiveTab('fines')}
            >
              <span className="icon">📋</span>
              Lista de Multas
            </button>
            <button 
              className={activeTab === 'history' ? 'active' : ''} 
              onClick={() => setActiveTab('history')}
            >
              <span className="icon">📜</span>
              Histórico
            </button>
          </div>

          <div className="nav-section">
            <span className="nav-section-title">Processos</span>
            <button 
              className={activeTab === 'appeals' ? 'active' : ''} 
              onClick={() => setActiveTab('appeals')}
            >
              <span className="icon">📝</span>
              Recursos
            </button>
          </div>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-avatar">{(user.email || 'U')[0].toUpperCase()}</span>
            <span className="user-name">{user.email}</span>
          </div>
          <button onClick={onLogout} className="logout-btn">Sair</button>
        </div>
      </aside>

      <main className="main-content">
        <header className="top-bar">
          <h1>
            {activeTab === 'dashboard' && 'Dashboard'}
            {activeTab === 'insights' && 'SARInsights'}
            {activeTab === 'chat' && 'SARzinho'}
            {activeTab === 'fines' && 'Lista de Multas'}
            {activeTab === 'history' && 'Histórico'}
            {activeTab === 'appeals' && 'Recursos'}
          </h1>
          <div className="top-bar-actions">
            <span className="date">{new Date().toLocaleDateString('pt-BR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </div>
        </header>

        <div className="content-area">
          {activeTab === 'dashboard' && <ConsolidatedData />}
          {activeTab === 'insights' && <ComingSoon title="SARInsights" description="Insights baseados nos dados extraídos das multas" />}
          {activeTab === 'chat' && <ComingSoon title="SARzinho" description="Chatbot para perguntas sobre gestão de multas" />}
          {activeTab === 'fines' && <FineManagement />}
          {activeTab === 'history' && <ComingSoon title="Histórico" description="Histórico completo de processamentos" />}
          {activeTab === 'appeals' && <AppealHistory onNavigate={onNavigate} />}
        </div>
      </main>
	 <FeedbackWidget />
    </div>
  );
}

function ComingSoon({ title, description }) {
  return (
    <div className="coming-soon">
      <div className="coming-soon-card">
        <span className="coming-soon-icon">🚀</span>
        <h2>{title}</h2>
        <p>{description}</p>
        <span className="badge">Em breve</span>
      </div>
    </div>
  );
}

export default Dashboard;
